export default {
  bookExperiencePanel: 'Panel pesan pengalaman',
  calendarIcon: 'Ikon kalender',
  coverImageForResource: 'Gambar sampul untuk pengalaman {{title}}',
  filterBy: 'Filter berdasarkan {{filter}}',
  filterByDateRange: 'Filter berdasarkan rentang tanggal',
  gallery: 'Galeri',
  goBack: 'Kembali ke halaman sebelumnya',
  hostUserIcon: 'ikon pengguna tuan rumah',
  imageOf: 'Gambar dari {{title}}',
  interactiveMapAltText: 'Peta interaktif dengan {{title}} yang dapat dipilih',
  mediaSlides: 'Slide media',
  muteVideo: 'Bisukan video',
  nextPhoto: 'Foto berikutnya',
  noVideoPlayback: 'Tidak ada kemampuan pemutaran video',
  pauseVideo: 'Jeda video',
  photoOf: 'foto dari {{name}}',
  playVideo: 'Putar video',
  previousPhoto: 'Foto sebelumnya',
  moreFiltersAndExperiences: 'Filter dan pengalaman lainnya',
  reserveSelectedSlot: 'Pesan slot yang dipilih',
  reviewRating: 'Peringkat ulasan {{rating}} dari 5',
  overallReviewRating: 'Peringkat ulasan keseluruhan {{rating}} dari 5',
  selectCountryCodeForPhoneNumber: 'Pilih kode negara untuk nomor telepon',
  selectDate: 'Pilih tanggal',
  selectParticipants: 'Pilih peserta',
  selectSessionTime: 'Pilih waktu sesi',
  unmuteVideo: 'Bunyikan video',
  viewShoppingCart: 'Lihat keranjang belanja',
  itemsInCart: '{{count}} item di keranjang belanja',
  zoomIn: 'Perbesar',
  zoomOut: 'Perkecil',
  selectData: 'Pilih {{data}}',
  reserveName: 'Pesan {{name}}',
  deleteReservation: 'Hapus reservasi {{experienceTitle}}',
  editParticipantsFor: 'Edit peserta untuk {{experienceTitle}}',
  enterPromoCode: 'Masukkan kode promo',
  applyPromoCode: 'Terapkan kode promo',
  increaseAddOnAmount: 'Tambah {{addOn}} yang dipilih',
  decreaseAddOnAmount: 'Kurangi {{addOn}} yang dipilih',
  addOnModal: 'Modal {{addOn}}',
  moreInformationAboutAddOn: 'Informasi lebih lanjut tentang {{addOn}}',
  decreasePriceTierTickets: 'Kurangi tiket {{priceTier}}',
  increasePriceTierTickets: 'Tambah tiket {{priceTier}}',
  downloadFilename: 'Unduh {{filename}}',
  viewFullDetailsDescription: 'Lihat deskripsi detail lengkap',
  viewFullDescription: 'Lihat deskripsi lengkap',
  closeModal: 'Tutup modal',
  hyattBanner: 'Spanduk Eksklusif Anggota World Of Hyatt',
  hyattBannerDesc:
    'Spanduk promosi yang menunjukkan manfaat dan penawaran eksklusif yang tersedia untuk anggota program loyalitas World of Hyatt',
  previousSlide: 'Slide sebelumnya',
  nextSlide: 'Slide berikutnya',
  paginationBulletMessage: 'Pergi ke slide',
  exitFullscreen: 'Keluar dari tampilan layar penuh',
  enterFullscreen: 'Masuk ke tampilan layar penuh',
  videoSlide: 'Slide video',
  imageSlide: 'Slide gambar',
  of: 'dari',
  noDescription: 'Tidak ada deskripsi',
  mediaGallery: 'Carousel - Galeri media',
  dateSelector: 'Pemilih tanggal',
  nextWeek: 'Minggu berikutnya',
  previousWeek: 'Minggu sebelumnya',
  scheduleAgenda: 'Agenda jadwal',
  scheduleNav: 'Navigasi jadwal',
  scheduleViewSelector: 'Pemilih tampilan jadwal',
  selectedDateAriaLabel: '{{date}}, dipilih',
  tapToBookExperience: 'Pesan {{title}}',
  bookExperienceAriaLabel: 'Pesan {{title}}',
  joinWaitlistAriaLabel: 'Bergabung dengan daftar tunggu untuk {{title}}',
};
